"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    menuItemClassNames: ()=>menuItemClassNames,
    useMenuItemStyles_unstable: ()=>useMenuItemStyles_unstable
});
const _react = require("@griffel/react");
const _index = require("../../selectable/index");
const menuItemClassNames = {
    root: 'fui-MenuItem',
    icon: 'fui-MenuItem__icon',
    checkmark: 'fui-MenuItem__checkmark',
    submenuIndicator: 'fui-MenuItem__submenuIndicator',
    content: 'fui-MenuItem__content',
    secondaryContent: 'fui-MenuItem__secondaryContent'
};
const useStyles = /*#__PURE__*/ (0, _react["__styles"])({
    focusIndicator: {
        Brovlpu: "ftqa4ok",
        B486eqv: "f2hkw1w",
        B8q5s1w: "f8hki3x",
        Bci5o5g: [
            "f1d2448m",
            "ffh67wi"
        ],
        n8qw10: "f1bjia2o",
        Bdrgwmp: [
            "ffh67wi",
            "f1d2448m"
        ],
        Bm4h7ae: "f15bsgw9",
        B7ys5i9: "f14e48fq",
        Busjfv9: "f18yb2kv",
        Bhk32uz: "fd6o370",
        Bf4ptjt: "fh1cnn4",
        kclons: [
            "fy7oxxb",
            "f184ne2d"
        ],
        Bhdgwq3: "fpukqih",
        Blkhhs4: [
            "f184ne2d",
            "fy7oxxb"
        ],
        Bqtpl0w: "frrh606",
        clg4pj: [
            "f1v5zibi",
            "fo2hd23"
        ],
        hgwjuy: "ful5kiu",
        Bonggc9: [
            "fo2hd23",
            "f1v5zibi"
        ],
        B1tsrr9: [
            "f1jqcqds",
            "ftffrms"
        ],
        Dah5zi: [
            "ftffrms",
            "f1jqcqds"
        ],
        Bkh64rk: [
            "f2e7qr6",
            "fsr1zz6"
        ],
        qqdqy8: [
            "fsr1zz6",
            "f2e7qr6"
        ],
        B6dhp37: "f1dvezut",
        i03rao: [
            "fd0oaoj",
            "f1cwg4i8"
        ],
        Boxcth7: "fjvm52t",
        Bsom6fd: [
            "f1cwg4i8",
            "fd0oaoj"
        ],
        J0r882: "fdiulkx",
        Bjwuhne: "f1yalx80",
        Ghsupd: [
            "fq22d5a",
            "f1jw7pan"
        ],
        Bule8hv: [
            "f1jw7pan",
            "fq22d5a"
        ]
    },
    root: {
        Bbmb7ep: [
            "f1aa9q02",
            "f16jpd5f"
        ],
        Beyfa6y: [
            "f16jpd5f",
            "f1aa9q02"
        ],
        B7oj6ja: [
            "f1jar5jt",
            "fyu767a"
        ],
        Btl43ni: [
            "fyu767a",
            "f1jar5jt"
        ],
        qhf8xq: "f10pi13n",
        sj55zd: "fkfq4zb",
        De3pzq: "fxugw4r",
        z189sj: [
            "f81rol6",
            "frdkuqy"
        ],
        uwmqm3: [
            "frdkuqy",
            "f81rol6"
        ],
        Bqenvij: "f1d2rq10",
        mc9l5x: "f22iagw",
        Bt984gj: "f122n59",
        Be2twd7: "fkhj508",
        Bceei9c: "f1k6fduh",
        i8kkvl: "f1q8lukm",
        Belr9w4: "f1ma2n7n",
        Jwef8y: "f1knas48",
        Bi91k9c: "fnwyq0v",
        Bk3fhr4: "ft1hn21",
        Bmfj8id: "fuxngvv",
        Bg7n49j: "fp258yr",
        famaaq: "f1xqy1su"
    },
    content: {
        uwmqm3: [
            "f161knb0",
            "f12huiiw"
        ],
        z189sj: [
            "f12huiiw",
            "f161knb0"
        ],
        De3pzq: "f3rmtva",
        Bh6795r: "fqerorx"
    },
    secondaryContent: {
        uwmqm3: [
            "f161knb0",
            "f12huiiw"
        ],
        z189sj: [
            "f12huiiw",
            "f161knb0"
        ],
        sj55zd: "f11d4kpn",
        Bi91k9c: "f1jp5ecu",
        t0hwav: "fc1cou1"
    },
    icon: {
        a9b677: "f64fuq3",
        Bqenvij: "fjamq6b",
        Be2twd7: "fe5j1ua",
        Bg96gwp: "fez10in",
        Bt984gj: "f122n59",
        mc9l5x: "ftuwxu6",
        Brf1p80: "f4d9j23"
    },
    submenuIndicator: {
        a9b677: "f64fuq3",
        Bqenvij: "fjamq6b",
        Be2twd7: "fe5j1ua",
        Bg96gwp: "fez10in",
        Bt984gj: "f122n59",
        mc9l5x: "ftuwxu6",
        Brf1p80: "f4d9j23"
    },
    disabled: {
        sj55zd: "f1s2aq7o",
        Bi91k9c: "fvgxktp",
        Bk3fhr4: "f19vpps7",
        Bmfj8id: "fv5swzo",
        Bg7n49j: "f1q1x1ba",
        t0hwav: "ft33916",
        Bbusuzp: "f1dcs8yz",
        ze5xyy: "f1kc2mi9",
        Bctn1xl: "fk56vqo",
        Bh6z0a4: "f1ikwg0d"
    }
}, {
    f: [
        ".ftqa4ok:focus{outline-style:none;}",
        ".fc1cou1:focus{color:var(--colorNeutralForeground3Hover);}",
        ".ft33916:focus{color:var(--colorNeutralForegroundDisabled);}"
    ],
    i: [
        ".f2hkw1w:focus-visible{outline-style:none;}"
    ],
    d: [
        ".f8hki3x[data-fui-focus-visible]{border-top-color:transparent;}",
        ".f1d2448m[data-fui-focus-visible]{border-right-color:transparent;}",
        ".ffh67wi[data-fui-focus-visible]{border-left-color:transparent;}",
        ".f1bjia2o[data-fui-focus-visible]{border-bottom-color:transparent;}",
        ".f15bsgw9[data-fui-focus-visible]::after{content:\"\";}",
        ".f14e48fq[data-fui-focus-visible]::after{position:absolute;}",
        ".f18yb2kv[data-fui-focus-visible]::after{pointer-events:none;}",
        ".fd6o370[data-fui-focus-visible]::after{z-index:1;}",
        ".fh1cnn4[data-fui-focus-visible]::after{border-top-style:solid;}",
        ".fy7oxxb[data-fui-focus-visible]::after{border-right-style:solid;}",
        ".f184ne2d[data-fui-focus-visible]::after{border-left-style:solid;}",
        ".fpukqih[data-fui-focus-visible]::after{border-bottom-style:solid;}",
        ".frrh606[data-fui-focus-visible]::after{border-top-width:2px;}",
        ".f1v5zibi[data-fui-focus-visible]::after{border-right-width:2px;}",
        ".fo2hd23[data-fui-focus-visible]::after{border-left-width:2px;}",
        ".ful5kiu[data-fui-focus-visible]::after{border-bottom-width:2px;}",
        ".f1jqcqds[data-fui-focus-visible]::after{border-bottom-right-radius:var(--borderRadiusMedium);}",
        ".ftffrms[data-fui-focus-visible]::after{border-bottom-left-radius:var(--borderRadiusMedium);}",
        ".f2e7qr6[data-fui-focus-visible]::after{border-top-right-radius:var(--borderRadiusMedium);}",
        ".fsr1zz6[data-fui-focus-visible]::after{border-top-left-radius:var(--borderRadiusMedium);}",
        ".f1dvezut[data-fui-focus-visible]::after{border-top-color:var(--colorStrokeFocus2);}",
        ".fd0oaoj[data-fui-focus-visible]::after{border-right-color:var(--colorStrokeFocus2);}",
        ".f1cwg4i8[data-fui-focus-visible]::after{border-left-color:var(--colorStrokeFocus2);}",
        ".fjvm52t[data-fui-focus-visible]::after{border-bottom-color:var(--colorStrokeFocus2);}",
        ".fdiulkx[data-fui-focus-visible]::after{top:-2px;}",
        ".f1yalx80[data-fui-focus-visible]::after{bottom:-2px;}",
        ".fq22d5a[data-fui-focus-visible]::after{left:-2px;}",
        ".f1jw7pan[data-fui-focus-visible]::after{right:-2px;}",
        ".f1aa9q02{border-bottom-right-radius:var(--borderRadiusMedium);}",
        ".f16jpd5f{border-bottom-left-radius:var(--borderRadiusMedium);}",
        ".f1jar5jt{border-top-right-radius:var(--borderRadiusMedium);}",
        ".fyu767a{border-top-left-radius:var(--borderRadiusMedium);}",
        ".f10pi13n{position:relative;}",
        ".fkfq4zb{color:var(--colorNeutralForeground2);}",
        ".fxugw4r{background-color:var(--colorNeutralBackground1);}",
        ".f81rol6{padding-right:10px;}",
        ".frdkuqy{padding-left:10px;}",
        ".f1d2rq10{height:32px;}",
        ".f22iagw{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;}",
        ".f122n59{-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;}",
        ".fkhj508{font-size:var(--fontSizeBase300);}",
        ".f1k6fduh{cursor:pointer;}",
        ".f1q8lukm{-webkit-column-gap:4px;column-gap:4px;}",
        ".f1ma2n7n{row-gap:4px;}",
        ".f1xqy1su{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;}",
        ".f161knb0{padding-left:2px;}",
        ".f12huiiw{padding-right:2px;}",
        ".f3rmtva{background-color:transparent;}",
        ".fqerorx{-webkit-box-flex:1;-webkit-flex-grow:1;-ms-flex-positive:1;flex-grow:1;}",
        ".f11d4kpn{color:var(--colorNeutralForeground3);}",
        ".f64fuq3{width:20px;}",
        ".fjamq6b{height:20px;}",
        ".fe5j1ua{font-size:20px;}",
        ".fez10in{line-height:0;}",
        ".ftuwxu6{display:-webkit-inline-box;display:-webkit-inline-flex;display:-ms-inline-flexbox;display:inline-flex;}",
        ".f4d9j23{-webkit-box-pack:center;-ms-flex-pack:center;-webkit-justify-content:center;justify-content:center;}",
        ".f1s2aq7o{color:var(--colorNeutralForegroundDisabled);}"
    ],
    h: [
        ".f1knas48:hover{background-color:var(--colorNeutralBackground1Hover);}",
        ".fnwyq0v:hover{color:var(--colorNeutralForeground2Hover);}",
        ".ft1hn21:hover .fui-Icon-filled{display:inline;}",
        ".fuxngvv:hover .fui-Icon-regular{display:none;}",
        ".fp258yr:hover .fui-MenuItem__icon{color:var(--colorNeutralForeground2BrandSelected);}",
        ".f1jp5ecu:hover{color:var(--colorNeutralForeground3Hover);}",
        ".fvgxktp:hover{color:var(--colorNeutralForegroundDisabled);}",
        ".f19vpps7:hover .fui-Icon-filled{display:none;}",
        ".fv5swzo:hover .fui-Icon-regular{display:inline;}",
        ".f1q1x1ba:hover .fui-MenuItem__icon{color:var(--colorNeutralForegroundDisabled);}"
    ],
    m: [
        [
            "@media (forced-colors: active){.f1dcs8yz{color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1kc2mi9:hover{color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.fk56vqo:hover .fui-MenuItem__icon{color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1ikwg0d:focus{color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ]
    ]
});
const useMenuItemStyles_unstable = (state)=>{
    const styles = useStyles();
    state.root.className = (0, _react.mergeClasses)(menuItemClassNames.root, styles.root, styles.focusIndicator, state.disabled && styles.disabled, state.root.className);
    if (state.content) {
        state.content.className = (0, _react.mergeClasses)(menuItemClassNames.content, styles.content, state.content.className);
    }
    if (state.checkmark) {
        state.checkmark.className = (0, _react.mergeClasses)(menuItemClassNames.checkmark, state.checkmark.className);
    }
    if (state.secondaryContent) {
        state.secondaryContent.className = (0, _react.mergeClasses)(menuItemClassNames.secondaryContent, !state.disabled && styles.secondaryContent, state.secondaryContent.className);
    }
    if (state.icon) {
        state.icon.className = (0, _react.mergeClasses)(menuItemClassNames.icon, styles.icon, state.icon.className);
    }
    if (state.submenuIndicator) {
        state.submenuIndicator.className = (0, _react.mergeClasses)(menuItemClassNames.submenuIndicator, styles.submenuIndicator, state.submenuIndicator.className);
    }
    (0, _index.useCheckmarkStyles_unstable)(state);
}; //# sourceMappingURL=useMenuItemStyles.js.map

//# sourceMappingURL=useMenuItemStyles.js.map